"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataExportJobClient = void 0;
const tslib_1 = require("tslib");
const new_crud_client_1 = require("../new.crud.client");
const data_export_utils_1 = require("./data-export-utils");
const query_params_1 = require("../utils/query-params");
class DataExportJobClient extends new_crud_client_1.NewCrudClient {
    getExportJobs(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { accountId, projectId, format, frequency, scope, state, order, page, limit } = request;
            const baseUrl = this.baseUrl(accountId);
            const queryParamsStr = (0, query_params_1.makeQueryParams)({ projectId, format, frequency, scope, state, order, page, limit });
            const url = `${baseUrl}?${queryParamsStr}`;
            return this._getExportJobs(url);
        });
    }
    getExportJobsWithUrl(fullUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const urlObj = new URL(fullUrl);
            const url = `${urlObj.pathname}${urlObj.search}`;
            return this._getExportJobs(url);
        });
    }
    _getExportJobs(url) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { success, payload, headers } = yield this.httpGet(url);
            if (!success) {
                return { jobs: [], values: [], links: {}, pageCount: 0 };
            }
            const links = (0, data_export_utils_1.readLinkHeader)(headers);
            return {
                jobs: payload,
                values: payload,
                links,
                pageCount: (0, data_export_utils_1.getLastPageNumber)((_a = links.last) !== null && _a !== void 0 ? _a : links.first),
            };
        });
    }
    getExportJob(accountId, projectId, jobId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.baseUrl(accountId);
            const queryParamsStr = (0, query_params_1.makeQueryParams)({ projectId });
            const url = `${baseUrl}/${jobId}?${queryParamsStr}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    createExportJob(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.baseUrl(request.accountId);
            const queryParamsStr = (0, query_params_1.makeQueryParams)({ projectId: request.projectId });
            const url = `${baseUrl}?${queryParamsStr}`;
            const response = yield this.httpPost(url, request.payload);
            return response.payload;
        });
    }
    updateExportJob(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const baseUrl = `${this.baseUrl(request.accountId)}/${request.jobId}`;
            const queryParamsStr = (0, query_params_1.makeQueryParams)({ projectId: request.projectId });
            const url = `${baseUrl}?${queryParamsStr}`;
            yield this.httpPatch(url, request.payload);
        });
    }
    updateExportJobState(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const baseUrl = `${this.baseUrl(request.accountId)}/${request.jobId}/${request.transition}`;
            const queryParamsStr = (0, query_params_1.makeQueryParams)({ projectId: request.projectId });
            const url = `${baseUrl}?${queryParamsStr}`;
            yield this.httpPatch(url);
        });
    }
    deleteExportJobs(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { accountId, projectId, jobIds } = request;
            const baseUrl = this.baseUrl(accountId);
            const queryParamsStr = (0, query_params_1.makeQueryParams)({ projectId, jobIds });
            const url = `${baseUrl}?${queryParamsStr}`;
            yield this.httpDelete(url);
        });
    }
    baseUrl(accountId) {
        return `/v1/accounts/${accountId}/exports`;
    }
}
exports.DataExportJobClient = DataExportJobClient;
//# sourceMappingURL=data-export-job.client.js.map